import React, { useState, useEffect, useCallback, ReactNode, FC } from 'react'

import { LoadMoreButton, LoadMoreContainer, NoContentMessage } from './styled'

interface PageContext {
    pageReviews: readonly Testimonial[]
    currentPage: number
    reviewsPerPage: number
    countPages: number
}

interface TestimonialEdge {
  node: Testimonial
}

type Props = {
  pageContext: PageContext
  setPageContext: any
  renderItem: any
  WrapperComponent: FC
  noContentMessage: string
}

const LoadMoreReviews = ({
  pageContext,
  setPageContext,
  renderItem,
  WrapperComponent,
  noContentMessage,
}: Props) => {
  const getReviewsToShow = useCallback(() => {
    if (pageContext.currentPage < pageContext.countPages) {
      const totalReviewsToShow = pageContext.currentPage * pageContext.reviewsPerPage
      return pageContext.pageReviews.slice(0, totalReviewsToShow)
    } else {
      return pageContext.pageReviews
    }
  }, [pageContext])
  const reviewSlice = getReviewsToShow()
  const [reviews, setReviews] = useState(reviewSlice)

  useEffect(() => {
    setReviews(getReviewsToShow())
  }, [pageContext])  // eslint-disable-line
  // ESLint will add deps to useEffect that cause an infinite loop

  const [isLoading, setIsLoading] = useState(false)
  const handleLoadMore = () => {
    setIsLoading(true)

    setPageContext((prevPageContext: PageContext) => (
      {
        ...prevPageContext,
        currentPage: prevPageContext.currentPage + 1
      }
    ))

    setIsLoading(false)
  }

  return (
    <>
      {reviews.length ? (
        <WrapperComponent>{reviews.map(renderItem)}</WrapperComponent>
      ) : (
        <NoContentMessage>{noContentMessage}</NoContentMessage>
      )}

      {pageContext.currentPage < pageContext.countPages && (
        <LoadMoreContainer>
          <LoadMoreButton disabled={isLoading} onClick={handleLoadMore}>
            {isLoading ? 'Loading reviews…' : 'Load More'}
          </LoadMoreButton>
        </LoadMoreContainer>
      )}
    </>
  )
}

export default LoadMoreReviews
